import { render, staticRenderFns } from "./createSign.vue?vue&type=template&id=616feb8b&scoped=true&"
import script from "./createSign.vue?vue&type=script&lang=js&"
export * from "./createSign.vue?vue&type=script&lang=js&"
import style0 from "./createSign.vue?vue&type=style&index=0&id=616feb8b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616feb8b",
  null
  
)

export default component.exports